// Exports
export default {
	"container": "container_MXbHR",
	"header": "header_eAKpW",
	"image": "image_GbZbo",
	"title": "title_BdU+i",
	"closeButton": "closeButton_OelfN",
	"content": "content_Hlcy8",
	"footer": "footer_FCWBt"
};
